var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['gs-box',_vm.customerClass]},[_c('div',{staticClass:"gs-box-title"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]}),_vm._t("other-content")],2),_c('div',{staticClass:"gs-box-body"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }